import * as React from 'react';
import { Entity } from '../../../data/types';

/**
 * @description creates filename for export
 */
export const useFilename = (
  base: string,
  entity: Entity,
  timeframe: string
): string => {
  const filename = React.useMemo((): string => {
    if (timeframe) {
      const mEntity = entity.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
      const mTimeframe = timeframe.replace(/[^a-z0-9]/gi, '_').toLowerCase();

      return `${base}_${mEntity}_${mTimeframe}.pdf`;
    } else {
      /// default
      return `${base}.pdf`;
    }
  }, [entity?.id, timeframe, base]);
  return filename;
};
